"use strict";
/**
 * @param {string} primaryColor - A string param (the base color to mix with another color).
 * @param {string} secondaryColor - A string param (the top layer color to mix with primary color).
 * @param {number} weight - A number param (How mush you want to opacify the secondary color, Ex: 50, Default value is 5)
 * @returns {string} the mixed color
 */
Object.defineProperty(exports, "__esModule", { value: true });
var mixColors = function (primaryColor, secondaryColor, weight) {
    function d2h(d) {
        return d.toString(16);
    } // convert a decimal value to hex
    function h2d(h) {
        return parseInt(h, 16);
    } // convert a hex value to decimal
    var weighted = typeof weight !== 'undefined' ? weight : 50; // set the weight to 50%, if that argument is omitted
    var color = '#';
    var pc = primaryColor.replace('#', '');
    var sc = secondaryColor.replace('#', '');
    for (var i = 0; i <= 5; i += 2) {
        // loop through each of the 3 hex pairs—red, green, and blue
        var v1 = h2d(pc.substr(i, 2)); // extract the current pairs
        var v2 = h2d(sc.substr(i, 2));
        // combine the current pairs from each source color, according to the specified weight
        var val = d2h(Math.floor(v2 + (v1 - v2) * (weighted / 100.0)));
        while (val.length < 2) {
            val = "0".concat(val);
        } // prepend a '0' if val results in a single digit
        color += val; // concatenate val to our new color string
    }
    return color; // PROFIT!
};
exports.default = mixColors;
